import React from "react";
import { connect } from "react-redux";
import AppFooter from "./modules/views/AppFooter";
import AppAppBar from "./modules/views/AppAppBar";
import LayoutBody from "./modules/components/LayoutBody";
import { app } from "backend/firebase";

import ReactJson from "react-json-view";

class ErrorComponent extends React.PureComponent {
    state = { json: {}, list: [], useList: false, errors: 0, exports: 0 };

    countSpecificError = (str, errors) => {
        let count = 0;
        for (const err of errors) {
            if (err.log && err.log.includes(str)) {
                count++;
            }
        }
        return count;
    };

    componentDidMount() {
        console.log(window.location);
        const urlParams = new URLSearchParams(window.location.search);
        const errId = urlParams.get("err");

        app.firestore()
            .collection("exports")
            .get()
            .then((querySnapshot) => {
                this.setState({ exports: querySnapshot.size });
            });

        if (errId) {
            console.log("getting err");
            app.firestore()
                .collection("errors")
                .doc(errId)
                .get()
                .then((res) => {
                    this.setState({ json: res.data() });
                    console.log("Result", res.data());
                })
                .catch((err) => {
                    console.log("Error", err);
                });
        } else {
            app.firestore()
                .collection("errors")
                .get()
                .then((snapshot) => {
                    const errors = snapshot.docs
                        .map((doc) => doc.data())
                        .sort((a, b) => b.time - a.time);

                    console.log(errors);

                    let internalErrCount = this.countSpecificError(
                        "Failed to create internal buffer",
                        errors
                    );
                    let genericCount = this.countSpecificError(
                        "Generic error in an external library",
                        errors
                    );

                    this.setState({
                        errors: snapshot.size,
                        json: errors,
                        internalErrCount,
                        genericCount
                    });
                })
                .catch((err) => console.log(err));
            return;
        }
    }

    render() {
        const percentage = (1.0 - this.state.errors / this.state.exports) * 100;

        return (
            <React.Fragment>
                <LayoutBody margin marginBottom>
                    <AppAppBar />
                    <div>
                        <div>errors: {this.state.errors}</div>
                        <div>malloc errors: {this.state.internalErrCount}</div>
                        <div>generic errors: {this.state.genericCount}</div>

                        <div>exports: {this.state.exports}</div>

                        <div>
                            success rate:
                            {percentage.toFixed(2)}%
                        </div>
                    </div>
                    <ReactJson collapsed src={this.state.json} />
                </LayoutBody>
                <AppFooter />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        code: state.error.code,
        message: state.error.message,
        title: state.error.title
    };
};

export default connect(mapStateToProps)(ErrorComponent);
